import React from 'react'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

interface StyledButtonPropsType {
  children?: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  className?: string
  type?: 'button' | 'submit' | 'reset'
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
  variant?: 'contained' | 'outlined' | 'text'
  style?: React.CSSProperties
}

const CustomButton = styled(Button)({
  backgroundColor: '#FB5012',
  textTransform: 'none',
  borderRadius: '38px',
  '&:hover': {
    backgroundColor: '#FB5012',
  },
  '&.Mui-disabled': {
    backgroundColor: '#FB5012',
    color: 'white',
    opacity: 0.5,
  },
})

const StyledButton = ({ children, ...props }: StyledButtonPropsType) => {
  return (
    <CustomButton variant="contained" {...props}>
      {children}
    </CustomButton>
  )
}

export default StyledButton
